import { Component, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SessionService } from './services/session/session.service';
import { AuthService } from './services/auth/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
  styles: []
})
export class AppComponent {
  /** Constructor to inject services that aren't injected anywhere else */
  constructor(
    private _sessionService: SessionService,
    private _authService: AuthService,
  ) { }

  @HostListener('document:click', ['$event'])
  handleClickEvent(event: MouseEvent): void {
    if (this._authService.isAuthenticated && !this._sessionService.dialogOpen) {
      this._sessionService.refresh();
    }
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyPressEvent(event: KeyboardEvent): void {
    if (this._authService.isAuthenticated && !this._sessionService.dialogOpen) {
      this._sessionService.refresh();
    }
  }
}
